import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { Can } from '../../hooks/usePermissions';
// Using Font Awesome for icons as a placeholder
// import { ReactComponent as DashboardIcon } from '../../assets/svg/dashboard2.svg';

const ClubPortalSidebar = () => {
    const { user } = useContext(AuthContext);
    const location = useLocation();

    /**
     * Helper function to check if the authenticated user has a specific role.
     * @param {string} roleName The name of the role to check for.
     * @returns {boolean} True if the user has the role, false otherwise.
     */
    const userHasRole = (roleName) => {
        return user?.roles?.some(role => role.name === roleName);
    };

    const checkIfActiveSidebar = (paths) => {
        let found = false;
        for (let key in paths) {
            if (paths[key] == location.pathname) {
                found = true;
                break;
            }
        }

        if (found) {
            return 'activesidebarselected';
        }
        else {
            return '';
        }


    };

    const isClubAdmin = userHasRole('club-admin');

    return (
        <div className="app-nav" id="app-simple-bar">
            <ul className="main-nav p-0 mt-2">

                {/* --- MAIN NAVIGATION (Visible to all members) --- */}
                <li className="menu-title"><span>Club Member Portal</span></li>
                <li className={`no-sub ${checkIfActiveSidebar(['/club_portal/dashboard'])}`}>
                    <Link to="/club_portal/dashboard">
                        <i className="fas fa-tachometer-alt me-2"></i> Dashboard
                    </Link>
                </li>
                <li className={`no-sub ${checkIfActiveSidebar(['/club_portal/games'])}`}>
                    <Link to="/club_portal/games">
                        <i className="fas fa-trophy me-2"></i> Games
                    </Link>
                </li>
                <li className={`no-sub ${checkIfActiveSidebar(['/club_portal/my-wallet'])}`}>
                    <Link to="/club_portal/my-wallet">
                        <i className="fas fa-wallet me-2"></i> My Wallet
                    </Link>
                </li>
                <li className={`no-sub ${checkIfActiveSidebar(['/club_portal/my-awards'])}`}>
                    <Link to="/club_portal/my-awards">
                        <i className="fas fa-award me-2"></i> My Awards
                    </Link>
                </li>

                <li className={`no-sub ${checkIfActiveSidebar(['/club_portal/members'])}`}>
                    <Link to="/club_portal/members">
                        <i className="fas fa-users me-2"></i> Members
                    </Link>
                </li>
                <li className={`no-sub ${checkIfActiveSidebar(['/club_portal/game-finances'])}`}>
                    <Link to="/club_portal/game-finances">
                        <i className="fas fa-calculator me-2"></i>  Game Finances
                    </Link>
                </li>
                <li className={`no-sub ${checkIfActiveSidebar(['/club_portal/balance-sheet'])}`}>
                    <Link to="/club_portal/balance-sheet">
                        <i className="fas fa-balance-scale me-2"></i>  Member Balances
                    </Link>
                </li>

               

               
                {/* <li className={`no-sub ${location.pathname.startsWith('/club_portal/members') ? 'activesidebarselected' : ''}`}>
                    <Link to="/club_portal/balance-sheet">
                        <i className="fas fa-balance-scale me-2"></i>  Summary Reports
                    </Link>
                </li> */}



                {/* --- NEW SETTINGS SECTION (for setup tasks) --- */}
                <li className="menu-title"><span>Club Funds & Events</span></li>

                <li className={`no-sub ${checkIfActiveSidebar(['/club_portal/financials/club-fund'])}`}>
                    <Link to="/club_portal/financials/club-fund">
                        <i className="fas  fa-glass-cheers me-2"></i> Club Fund
                    </Link>
                </li>



                <li className={`no-sub ${checkIfActiveSidebar(['/club_portal/club-events'])}`}>
                    <Link to="/club_portal/club-events">
                        <i className="fas  fa-glass-cheers me-2"></i> Club Events
                    </Link>
                </li>



                 {/* --- NEW SETTINGS SECTION (for setup tasks) --- */}
                <li className="menu-title"><span>Club Reports</span></li>

                <li className={`no-sub ${checkIfActiveSidebar(['/club_portal/reports/club-finance'])}`}>
                    <Link to="/club_portal/reports/club-finance">
                        <i className="fas fa-chart-bar me-2"></i> Club Finance Reports
                    </Link>
                </li>

              



                {/* --- CLUB ADMINISTRATION (Visible only to Club Admins) --- */}

                <>
                    <Can any={['list-users', 'list-permissions', 'list-roles', 'list-turf-bookings', 'generate-awards', 'list-venues', 'list-sponsors', 'list-head-of-accounts', 'list-member-opening-balances', 'list-club-fund-opening-balances']}>
                        <li className="menu-title"><span>Club Administration</span></li>
                    </Can>

                    {/* Access Control Group */}
                    <Can any={['list-users', 'list-permissions', 'list-roles']}>
                        <li>
                            <a
                                className={`${checkIfActiveSidebar(['/club_portal/users', '/club_portal/roles', '/club_portal/permissions'])}`}
                                aria-expanded="false"
                                data-bs-toggle="collapse"
                                href="#access-control"
                            >
                                <i className="fas fa-user-shield me-2"></i> Access Control
                            </a>
                            <ul className="collapse" id="access-control">
                                <Can any={['list-users']}>
                                    <li><Link to="/club_portal/users">Users</Link></li>
                                </Can>
                                <Can any={['list-roles']}>
                                    <li><Link to="/club_portal/roles">Roles</Link></li>
                                </Can>
                                <Can any={['list-permissions']}>
                                    <li><Link to="/club_portal/permissions">Permissions</Link></li>
                                </Can>
                            </ul>
                        </li>

                    </Can>

                    <Can any={['create-turf-booking']}>
                        <li className={`no-sub ${checkIfActiveSidebar(['/club_portal/bookings'])}`}>
                            <Link to="/club_portal/bookings">
                                <i className="fas fa-calendar-alt me-2"></i> Turf Bookings
                            </Link>
                        </li>
                    </Can>

                    <Can any={['generate-awards']}>
                        <li className={`no-sub ${checkIfActiveSidebar(['/club_portal/awards'])}`}>
                            <Link to="/club_portal/awards">
                                <i className="fas fa-award me-2"></i> Generate Awards
                            </Link>
                        </li>
                    </Can>

                    <Can any={['list-venues', 'list-sponsors', 'list-head-of-accounts']}>
                        <li>
                            <a
                                className={`${checkIfActiveSidebar(['/club_portal/venues', '/club_portal/sponsors', '/club_portal/head-of-accounts'])}`}
                                aria-expanded="false"
                                data-bs-toggle="collapse"
                                href="#club-masters"
                            >
                                <i className="fas fa-user-shield me-2"></i> Club Masters
                            </a>
                            <ul className="collapse" id="club-masters">
                                <Can any={['list-venues']}>
                                    <li>

                                        <Link to="/club_portal/venues">
                                            <i className="fas fa-map-marker-alt me-2"></i> Venues
                                        </Link>
                                    </li>
                                </Can>


                                <Can any={['list-sponsors']}>
                                    <li>
                                        <Link to="/club_portal/sponsors"><i className="fas fa-handshake me-2"></i> Sponsors</Link>

                                    </li>
                                </Can>
                                <Can any={['create-head-of-account']}>
                                    <li>
                                        <Link to="/club_portal/head-of-accounts">
                                            <i className="fas fa-book me-2"></i>Head of Accounts
                                        </Link>
                                    </li>
                                </Can>


                            </ul>
                        </li>
                    </Can>





                    <Can any={['list-member-opening-balances', 'list-club-fund-opening-balances']}>
                        <li>
                            <a
                                className={`${checkIfActiveSidebar(['/club_portal/opening-balances', '/club_portal/financials/club-fund-opening-balance'])}`}
                                aria-expanded="false"
                                data-bs-toggle="collapse"
                                href="#financials"
                            >
                                <i className="fas fa-file-invoice-dollar me-2"></i> Opening Balances
                            </a>
                            <ul className="collapse" id="financials">
                                <Can any={['list-member-opening-balances']}>
                                    <li><Link to="/club_portal/opening-balances">Member OB</Link></li>
                                </Can>
                                <Can any={['list-club-fund-opening-balances']}>
                                    <li><Link to="/club_portal/financials/club-fund-opening-balance">Club OB</Link></li>
                                </Can>

                            </ul>
                        </li>
                    </Can>

                    <Can any={['create-wallet-transaction']}>
                        <li className={`no-sub ${checkIfActiveSidebar(['/club_portal/payments-view'])}`}>
                            <Link to="/club_portal/payments-view">
                                <i className="fas fa-award me-2"></i> Payments View
                            </Link>
                        </li>
                    </Can>

                    {/* old routes
                         <li>
                            <a
                                className={`${location.pathname.includes('/financials') ? 'activesidebarselected' : ''}`}
                                aria-expanded="false"
                                data-bs-toggle="collapse"
                                href="#financials"
                            >
                                <i className="fas fa-file-invoice-dollar me-2"></i> Financials
                            </a>
                            <ul className="collapse" id="financials">

                                <li><Link to="/club_portal/contributions">Game Contributions</Link></li>
                                <li><Link to="/club_portal/expenses">Club Expenses</Link></li>
                                <li><Link to="/club_portal/financials/ledgers">Member Ledgers</Link></li>
                                 <li>
                                    <Link to="/club_portal/opening-balances">
                                        <i className="fas fa-upload me-2"></i> Opening Balances
                                    </Link>
                                </li>

                            </ul>
                        </li> */}



                    {/* <li>
                            <a
                                className={`${location.pathname.includes('/club_funds') ? 'activesidebarselected' : ''}`}
                                aria-expanded="false"
                                data-bs-toggle="collapse"
                                href="#club_funds"
                            >
                                <i className="fas fa-file-invoice-dollar me-2"></i> Financials
                            </a>
                            <ul className="collapse" id="club_funds">

                                <li><Link to="/club_portal/financials/club-fund">Club Fund</Link></li>
                                <li><Link to="/club_portal/financials/club-fund-opening-balance">Opening Balance</Link></li>
                            </ul>
                        </li> */}







                </>

            </ul>
        </div>
    );
};

export default ClubPortalSidebar;

